/**
 * ShiftPatternEditor — Műszakminták admin tábla (readonly MVP)
 * PAY-12: HR /shifts API (Sprint 4) újrafelhasználása
 * Szerkesztés/létrehozás a HR admin felületén marad — itt csak megjelenítés.
 */

import { useTranslation } from '@kgc/i18n';
import {
  Badge,
  Card,
  CardContent,
  CardHeader,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@kgc/ui';
import { useQuery } from '@tanstack/react-query';
import { listShifts } from '../../hr/api/hr-api';

export function ShiftPatternEditor() {
  const { t } = useTranslation();
  const { data, isLoading, error } = useQuery({
    queryKey: ['hr', 'shifts'],
    queryFn: async () => {
      const res = await listShifts();
      return res.data;
    },
    staleTime: 5 * 60_000,
  });

  return (
    <Card>
      <CardHeader>
        <p className="text-sm text-muted-foreground">{t('payroll.shift.editHint')}</p>
      </CardHeader>
      <CardContent>
        {isLoading && <p className="text-sm text-muted-foreground py-4">{t('common.loading')}</p>}
        {error && <p className="text-sm text-destructive py-4">{t('payroll.shift.loadError')}</p>}
        {data && data.length === 0 && (
          <p className="text-sm text-muted-foreground py-4">{t('payroll.shift.empty')}</p>
        )}
        {data && data.length > 0 && (
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>{t('payroll.shift.nameHeader')}</TableHead>
                <TableHead>{t('payroll.shift.startHeader')}</TableHead>
                <TableHead>{t('payroll.shift.endHeader')}</TableHead>
                <TableHead>{t('payroll.shift.breakHeader')}</TableHead>
                <TableHead>{t('payroll.shift.night')}</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {data.map(shift => (
                <TableRow key={shift.id}>
                  <TableCell className="font-medium">{shift.name}</TableCell>
                  <TableCell className="text-sm">{shift.startTime}</TableCell>
                  <TableCell className="text-sm">{shift.endTime}</TableCell>
                  <TableCell className="text-sm">{shift.breakMinutes}</TableCell>
                  <TableCell>
                    {shift.isNightShift ? (
                      <Badge variant="outline">{t('payroll.shift.night')}</Badge>
                    ) : (
                      <span className="text-muted-foreground text-sm">—</span>
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </CardContent>
    </Card>
  );
}
